/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShadowButton/view.blocks to change it.
import "DesignSystem/Fonts/Inter-700.css"
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ShadowButton({
  children,
  viewPath = "/DesignSystem/ShadowButton",
  marginTop = 0,
  marginBottom = 0
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ShadowButton.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z2eUtJg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-2-Z2eUtJg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ShadowButton.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="ShadowButton.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Check in
</span>
</div>
<div
  data-testid="ShadowButton.Vertical:2"
  data-view-path={viewPath}
 center={0}
 className={`views-block ${styles.Vertical2}`}
/>
</div>
{children}
</React.Fragment>)
}